<template>
    <div id="form-modal">
        <div class="title">{{ $t("message.addAnItem") }}</div>
        <a-select v-model="input.type" show-search class="types">
            <a-select-option v-for="(type, index) of types" :key="index" :value="type.value">
                {{ type.label }}
            </a-select-option>
        </a-select>
        <div class="input-area">
            <input class="label-input" v-model="input.label" :placeholder="$t('message.newTitleContent')" />
        </div>
        <div class="required-container">
            <input class="input-checkbox" type="checkbox" v-model="input.required" />
            <span class="text">{{$t("message.required")}}</span>
        </div>
        <div class="footer">
            <span class="btn" @click="$emit('close')">{{ $t("message.cancel") }}</span>
            <span class="btn add" @click="saveItem()">{{$t("message.saveItem")}}</span>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { log2 } from "../../../../../utils/log2";

const log = log2("FormModal");
export default {
    name: "Form",
    components: {},
    props: {
        data: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            types: [
                { label: this.$t("message.phoneNumber"), value: "phone" },
                { label: this.$t("message.customItem"), value: "custom" },
            ],
            input: {
                type: "custom",
                label: "",
                required: false,
            },
        };
    },
    computed: {
        ...mapState({}),
    },
    methods: {
        ...mapActions({}),
        saveItem() {
            this.$emit("input", this.input);
        },
    },
    async mounted() {
        this.input = Object.keys(this.data).length > 0 ? this.data : this.input;
    },
    beforeDestroy() {},
    watch: {
        data: {
            handler: function (val) {
                this.input = Object.keys(val).length > 0 ? val : this.input;
            },
            deep: true,
        },
    },
};
</script>

<style>
#form-modal {
    .ant-select-selection {
        background-color: #ececec !important;
    }

    .ant-modal-content {
        width: 20vw;
    }
}
</style>

<style lang="scss" scoped>
#form-modal {
    display: flex;
    flex-direction: column;
    align-items: start;

    .types {
        margin-top: 10px;
        width: 100%;
    }

    .title {
        font-weight: 600;
        font-size: 20px;
    }

    .input-area {
        width: 100%;
    }

    .required-container {
        display: flex;
        align-items: center;
        margin-top: 10px;

        .text {
            margin-left: 5px;
        }
    }

    .label-input {
        border: none;
        border-bottom: 1px solid grey;
        margin-top: 10px;
        background-color: #ececec;
        width: 100%;
        border-radius: 5px;
        padding: 3px;
    }

    .footer {
        display: flex;
        justify-content: end;
        width: 100%;
        align-items: center;

        .btn {
            margin-right: 10px;
            font-weight: 500;
            font-size: 15px;
            cursor: pointer;

            &.add {
                color: rgb(26, 115, 232);
            }
        }
    }
}
</style>
